import { parse, format, isValid } from 'date-fns';

/**
 * Safely formats a ship date to "MMMM d, yyyy", ignoring timezone.
 * Treats the date as a local calendar date (without timezone shift).
 * Returns empty string if null, undefined, or invalid.
 */
export function formatShipDate(dateStr?: string | null): string {
  if (!dateStr) return "";

  try {
    const datePart = dateStr.split('T')[0]; 
    const parsed = parse(datePart, 'yyyy-MM-dd', new Date());
    return isValid(parsed) ? format(parsed, 'MMMM d, yyyy') : "";
  } catch {
    return "";
  }
}
